import React from "react";

import Testimonials from "../../components/shared/testimonials";

import TestiLightDesktopBg from "../../images/virtual-internship/vi-testimonial-bg-desktop-light.png";
import TestiLightMobileBg from "../../images/virtual-internship/vi-testimonial-bg-mobile-light.png";
import TestiDarkDesktopBg from "../../images/virtual-internship/vi-testimonial-bg-desktop-dark.png";
import TestiDarkMobileBg from "../../images/virtual-internship/vi-testimonial-bg-mobile-dark.png";

export const VITestimonials = ({ testimonials }) => {
  return (
    <Testimonials
      testimonials={testimonials}
      type="program"
      form_type="gvivirtual_application_form"
      bgSrc={{
        light: { desktop: TestiLightDesktopBg, mobile: TestiLightMobileBg },
        dark: { desktop: TestiDarkDesktopBg, mobile: TestiDarkMobileBg }
      }}
      bgCol="bg-gray-lighten dark:bg-gray-darker"
      calendlyLayout={"popup"}
      calendlyDesc={"Alternatively, schedule a call time above via Calendly."}
      formStatusExtraContainerClass={""}
      formStatusIconColorClass={"text-white fill-white"}
      formStatusHeadingTextProcessing={"Just a moment..."}
      formStatusBriefTextProcessing={
        "We're making sure we have everything we need before connecting you with one of our team members."
      }
      formStatusHeadingTextSuccess={"Thank you!"}
      formStatusBriefTextSuccess={
        "One of our expert consultants will be in touch within 12 hours. If you can't wait to speak to us, you can call us on INTL_NUMBER"
      }
    />
  );
};
